import type { Props } from '@blocknote/core';
import type { TokenValueMetadata } from '../../utils/blocknote-document/types/token';

export const TOKEN_INLINE_CONFIG = {
  type: 'token',
  content: 'none',
  propSchema: {
    tokenId: { default: '' },
    tokenName: { default: '' },
    tokenType: { default: '' },
    label: { default: '' },
    value: { default: '' },
    options: { default: '[]' },
    required: { default: false },
    confirmationRequired: { default: false },
    confirmed: { default: false },
    backendMapping: { default: '' },
    resourceType: { default: '' },
    autoFillStatus: { default: false },
    autoFillDebug: { default: '' },
    valueMetadataJson: { default: '' },
    // Stamped by template hydration ('static_text') for static-presentation
    // templates; empty for editable tokens. Drives read-only em-dash rendering.
    tokenPresentation: { default: '' },
  },
} as const;

export type TokenInlineProps = Props<typeof TOKEN_INLINE_CONFIG.propSchema> & {
  valueMetadata?: TokenValueMetadata;
};
